import riot from 'riot';
import events from '../src/events.js';
import { getDeviceTelemetry as libGetDeviceTelemetry, getDeviceMonitors as libGetDeviceMonitors, putDevice as libPutDevice, deleteMonitor as libDeleteMonitor, postDirectMethod as libPostDirectMethod } from '../src/lib.js';
riot.tag2('device-details', '<div class="container is-fluid has-text-centered" show="{device_details_loading}" style="margin-top: 20px;"> <progress class="progress is-large" max="100">60%</progress> </div> <nav class="navbar" role="navigation" aria-label="main navigation" if="{!device_details_loading}" style="background-color: rgb(245,245,245); border-bottom: 1px solid #dbdbdb;"> <div class="navbar-brand"> <span class="navbar-item"> <span class="icon has-text-info" style="margin-right: 0.4rem;"><i class="fas fa-microchip"></i></span> <span class="has-text-weight-semibold">Kit Details</span> </span> </div> <div class="navbar-menu is-active"> <div class="navbar-end"> <div class="navbar-item"> <div class="buttons"> <button class="button is-info" onclick="{toggleSensorsClick}"> <span class="icon is-small"><i class="fas fa-microchip"></i></span> <span>{showSensors ? \'Measurements\' : \'Sensors\'}</span> </button> <button class="button is-danger" onclick="{exitDeviceDetailsClick}"> <span class="icon is-small"><i class="fas fa-times"></i></span> <span>Close</span> </button> </div> </div> </div> </div> </nav> <div class="columns is-multiline" if="{!device_details_loading}" style="margin-top: 5px;"> <div class="column is-12"> <div class="card" style="display:flex; flex-direction:column;"> <div class="card-content"> <div class="media"> <div class="media-left"> <figure class="image is-48x48"> <img if="{selectedDevice.device_type==\'Filament\'}" src="img/brand/Filament_Logo_Mark_Navy.png" alt="Filament Icon"> <img if="{selectedDevice.device_type!=\'Filament\'}" src="img/byod_device.png" alt="BYOD Icon"> </figure> </div> <div class="media-content"> <p class="title is-4">{selectedDevice.device_name}</p> <p class="subtitle is-6">{selectedDevice.device_id}</p> </div> <div class="media-right"> <button class="button is-loading" if="{parent.loadingStatus[selectedDevice.device_id]}"></button> <div class="tags has-addons" if="{parent.loadingStatus[selectedDevice.device_id]==false}"> <span class="tag is-medium is-{parent.getStatusTag(selectedDevice.status)}">{parent.getStatusTagLabel(selectedDevice.status)}</span> <a class="tag is-medium is-{parent.getStatusTag(selectedDevice.status)}" onclick="{parent.refreshDeviceStatusClick}" style="text-decoration: none;"> <span class="icon is-small"> <i class="fas fa-sync"></i> </span> </a> </div> </div> </div> <div class="content"> <div class="field"> <div class="control"> <button class="button is-info is-light" onclick="{startRenameInline}" if="{!isRenaming}"> <span class="icon is-small"> <i class="fas fa-edit"></i> </span> <span>Rename Kit</span> </button> </div> </div> <div class="field" if="{isRenaming}"> <label class="label">New Kit Name</label> <div class="field has-addons"> <div class="control is-expanded"> <input class="input" type="text" riot-value="{renameDeviceName}" oninput="{onRenameInput}" placeholder="Enter a new kit name"> </div> <div class="control"> <button class="button is-success {savingEdits ? \'is-loading\' : \'\'}" onclick="{saveRenameClick}" disabled="{!canSaveRename() || savingEdits}">Save</button> </div> <div class="control"> <button class="button" onclick="{cancelRenameInline}" disabled="{savingEdits}">Cancel</button> </div> </div> <p class="help is-danger" if="{renameError}">{renameError}</p> </div> <div class="field is-grouped is-grouped-multiline"> <div class="control"> <button class="button {updateAvailable ? \'is-danger\' : \'is-warning\'} {parent.loadingFirmwareUpdate[parent.selectedDevice.device_id] ? \'is-loading\' : \'\'}" onclick="{firmwareUpdateClick}" disabled="{parent.loadingFirmwareUpdate[parent.selectedDevice.device_id] || !parent.selectedDevice.status}" title="{!parent.selectedDevice.status ? \'Device is offline\' : \'\'}"> <span class="icon is-small" if="{!parent.loadingFirmwareUpdate[parent.selectedDevice.device_id]}"> <i class="fas fa-download"></i> </span> <span if="{!parent.loadingFirmwareUpdate[parent.selectedDevice.device_id] && !updateAvailable}">Update Firmware</span> <span if="{!parent.loadingFirmwareUpdate[parent.selectedDevice.device_id] && updateAvailable}">Update Available!</span> <span if="{parent.loadingFirmwareUpdate[parent.selectedDevice.device_id]}">Updating...</span> </button> </div> <div class="control"> <a class="button is-danger" href="/dist/smartkits" target="_blank"> Download Firmware </a> </div> <div class="control"> <div class="tags has-addons "> <span class="tag is-large is-dark ">Device Type</span> <span class="tag is-large is-info ">{parent.selectedDevice.device_type}</span> </div> </div> <div class="control"> <div class="tags has-addons "> <span class="tag is-large is-dark ">Kit Type</span> <span class="tag is-large is-info ">{parent.selectedDevice.kit_type}</span> </div> </div> </div> <div class="notification is-warning is-light" if="{parent.selectedDevice.updateStatus === \'initiating\'}" style="margin-top: 10px;"> <button class="delete" onclick="{closeFirmwareNotification}"></button> <p class="title is-6"> <span class="icon is-small"> <i class="fas fa-spinner fa-pulse"></i> </span> Firmware Update in Progress </p> <p>{parent.selectedDevice.updateMessage}</p> <progress class="progress is-warning" max="100"> Contacting device... </progress> </div> <div class="notification is-success" if="{parent.selectedDevice.updateStatus === \'success\'}" style="margin-top: 10px;"> <button class="delete" onclick="{closeFirmwareNotification}"></button> <p class="title is-6"> <span class="icon is-small"> <i class="fas fa-check-circle"></i> </span> Firmware Update Status </p> <p>{parent.selectedDevice.updateMessage}</p> </div> <div class="notification is-warning" if="{parent.selectedDevice.updateStatus === \'pending\'}" style="margin-top: 10px;"> <button class="delete" onclick="{closeFirmwareNotification}"></button> <p class="title is-6"> <span class="icon is-small"> <i class="fas fa-clock"></i> </span> Firmware Update In Progress </p> <p>{parent.selectedDevice.updateMessage}</p> <progress class="progress is-warning" max="100"> Rebooting device... </progress> </div> <div class="notification is-danger" if="{parent.selectedDevice.updateStatus === \'error\'}" style="margin-top: 10px;"> <button class="delete" onclick="{closeFirmwareNotification}"></button> <p class="title is-6"> <span class="icon is-small"> <i class="fas fa-exclamation-triangle"></i> </span> Firmware Update Failed </p> <p>{parent.selectedDevice.updateMessage}</p> </div> <div class="notification is-success" if="{parent.selectedDevice.resetWifiStatus === \'success\'}" style="margin-top: 10px;"> <button class="delete" onclick="{closeWifiNotification}"></button> <p class="title is-6"> <span class="icon is-small"> <i class="fas fa-wifi"></i> </span> WiFi Reset Status </p> <p>{parent.selectedDevice.resetWifiMessage}</p> </div> <div class="notification is-danger" if="{parent.selectedDevice.resetWifiStatus === \'error\'}" style="margin-top: 10px;"> <button class="delete" onclick="{closeWifiNotification}"></button> <p class="title is-6"> <span class="icon is-small"> <i class="fas fa-exclamation-triangle"></i> </span> WiFi Reset Failed </p> <p>{parent.selectedDevice.resetWifiMessage}</p> </div> <article class="message is-dark" style="margin-top: .75rem;"> <div class="message-header"> <p> <span class="icon"> <i class="fas fa-microchip"></i> </span> System Information </p> </div> <div class="message-body"> <div class="notification is-warning is-light" if="{!firmwareLoading && updateAvailable}" style="margin-bottom: 20px; border-left: 4px solid #ff9800;"> <button class="delete" onclick="{dismissUpdateBanner}"></button> <div style="display: flex; align-items: center;"> <span class="icon is-large" style="margin-right: 15px; flex-shrink: 0;"> <i class="fas fa-exclamation-triangle fa-2x"></i> </span> <div style="flex: 1;"> <p style="font-weight: 600; font-size: 1.1rem; margin-bottom: 8px; color: #333;">Firmware Update Available</p> <p style="margin-bottom: 10px; color: #555;"> A new firmware version <strong>{self.LATEST_FIRMWARE_VERSION}</strong> is available for this device. <span if="{firmwareInfo}"> Current version: <strong>{getCurrentFirmwareVersion()}</strong></span> </p> <button class="button is-warning is-small" onclick="{scrollToUpdateButton}"> <span class="icon is-small"> <i class="fas fa-download"></i> </span> <span>Update Now</span> </button> </div> </div> </div> <div class="has-text-centered" if="{firmwareLoading}"> <progress class="progress" max="100"> Loading system information... </progress> <p class="has-text-grey">Retrieving system information from device...</p> </div> <div class="columns is-multiline" if="{!firmwareLoading}"> <div class="column is-half" each="{info in firmwareInfo}"> <div class="box"> <div class="content"> <p class="heading has-text-{getFirmwareInfoDisplay(info.type).color}">{getFirmwareInfoDisplay(info.type).label}</p> <p class="has-text-dark has-text-weight-semibold is-size-6-mobile is-size-5-tablet">{info.value}</p> <p class="has-text-right"> <span class="icon is-large has-text-{getFirmwareInfoDisplay(info.type).color}"> <i class="{getFirmwareInfoDisplay(info.type).icon}"></i> </span> </p> </div> </div> </div> </div> <div class="field"> <div class="control"> <button class="button is-info is-outlined" onclick="{firmwareInfoClick}" disabled="{!parent.selectedDevice.status}" title="{!parent.selectedDevice.status ? \'Device is offline\' : \'\'}"> <span class="icon"> <i class="fas fa-sync"></i> </span> <span>Refresh System Info</span> </button> </div> </div> </div> </article> <article class="message " style="margin-top: .75rem; "> <div class="message-header "> <p>Active Lessons</p> </div> <div class="message-body "> <div class="tags are-large" if="{parent.activities}"> <span class="tag is-info " each="{a in parent.activities}" if="{a.device_ids.includes(parent.selectedDevice.device_id) && a.active}" onclick="{parent.clickedActivityRef}">{a.activity_ref}</span> </div> <div class="container is-fluid has-text-centered " show="{!parent.activities}" style="margin-top: 5px; "> <progress class="progress is-large " max="100 ">60%</progress> </div> </div> </article> <article class="message " style="margin-top: .75rem; "> <div class="message-header "> <p>Monitors</p> </div> <div class="message-body "> <monitors if="{!monitorsLoading}"></monitors> <div class="container is-fluid has-text-centered " show="{monitorsLoading}" style="margin-top: 5px; "> <progress class="progress is-large " max="100 ">60%</progress> </div> </div> </article> </div> </div> </div> <div class="card " show="{!showSensors}" style="display:flex; flex-direction:column; margin-top:5px; "> <div class="card-content "> <div class="content "> <h5 class="title ">Measurements</h5> <measurements></measurements> </div> </div> </div> <div class="card " show="{showSensors}" style="display:flex; flex-direction:column; margin-top:5px;"> <div class="card-content "> <div class="content "> <h5 class="title ">Sensor Configurations</h5> <sensors></sensors> </div> </div> </div> </div>', '', '', function(opts) {
            var self = this;
            self.device_details_loading = false;
            self.telemetryLoading = false;
            self.monitorsLoading = false;
            self.showSensors = true;
            self.savingEdits = false;
            self.selectedDevice = self.parent.selectedDevice;
            self.firmwareInfo = null;
            self.firmwareLoading = false;
            self.lastFirmwareDeviceId = null;
            self.updateAvailable = false;
            self.isRenaming = false;
            self.renameDeviceName = '';
            self.renameError = undefined;

            self.LATEST_FIRMWARE_VERSION = "1.2.4";

            function isUpdateAvailable(currentVersion, latestVersion) {
                if (!currentVersion || !latestVersion) return false;
                const current = currentVersion.split('.').map(Number);
                const latest = latestVersion.split('.').map(Number);
                for (let i = 0; i < 3; i++) {
                    if (latest[i] > current[i]) return true;
                    if (latest[i] < current[i]) return false;
                }
                return false;
            }

            this.getCurrentFirmwareVersion = function() {
                if (!self.firmwareInfo || !Array.isArray(self.firmwareInfo)) return 'Unknown';
                const versionInfo = self.firmwareInfo.find(item => item.type === 'firmware_version');
                return versionInfo ? versionInfo.value : 'Unknown';
            }.bind(this)

            this.dismissUpdateBanner = function(e) {
                e.preventDefault();
                self.updateAvailable = false;
                self.update();
            }.bind(this)

            this.scrollToUpdateButton = function(e) {
                e.preventDefault();

                self.firmwareUpdateClick(e);
            }.bind(this)

            events.on('select_device', function(payload) {
                const { selectedDevice, view, params } = payload || {};

                self.selectedDevice = selectedDevice;
                self.isRenaming = false;
                self.renameDeviceName = selectedDevice && selectedDevice.device_name ? selectedDevice.device_name : '';
                self.renameError = undefined;

                if (view === 'measurements') {
                    self.showSensors = false;
                } else if (view === 'sensors') {
                    self.showSensors = true;
                } else {

                    self.showSensors = true;
                }

                self.update();
                getDeviceTelemetry(selectedDevice.device_id);
                getDeviceMonitors(selectedDevice.device_id);

                if (!self.firmwareInfo || self.lastFirmwareDeviceId !== selectedDevice.device_id) {
                    self.lastFirmwareDeviceId = selectedDevice.device_id;
                    setTimeout(function() {
                       self.firmwareInfoClick();
                    }, 100);
                }
            });

            this.exitDeviceDetailsClick = function(e) {
                routerHelpers.navigate('devices');
            }.bind(this)

            this.toggleSensorsClick = function(e) {
                self.showSensors = !self.showSensors;

                const view = self.showSensors ? 'sensors' : 'measurements';
                routerHelpers.syncURL('devices', self.selectedDevice.device_id, view);

                self.update();
            }.bind(this)

            this.startRenameInline = function(e) {
                self.renameDeviceName = self.parent.selectedDevice && self.parent.selectedDevice.device_name ? self.parent.selectedDevice.device_name : '';
                self.renameError = undefined;
                self.isRenaming = true;
                self.update();
            }.bind(this)

            this.cancelRenameInline = function(e) {
                if (self.savingEdits) {
                    return;
                }
                self.isRenaming = false;
                self.renameError = undefined;
                self.update();
            }.bind(this)

            this.onRenameInput = function(e) {
                self.renameDeviceName = e.target.value;
                if (self.renameError) {
                    self.renameError = undefined;
                }
                self.update();
            }.bind(this)

            this.canSaveRename = function() {
                var newName = (self.renameDeviceName || '').trim();
                var currentName = (self.parent.selectedDevice && self.parent.selectedDevice.device_name ? self.parent.selectedDevice.device_name : '').trim();
                return !!newName && newName !== currentName;
            }.bind(this)

            this.saveRenameClick = function(e) {
                var newDeviceName = (self.renameDeviceName || '').trim();
                if (!newDeviceName) {
                    self.renameError = 'Kit name cannot be empty.';
                    self.update();
                    return;
                }

                if (newDeviceName === self.parent.selectedDevice.device_name) {
                    self.renameError = 'Please enter a different name.';
                    self.update();
                    return;
                }

                var data = {
                    "device": self.parent.selectedDevice.device_id,
                    "name": newDeviceName
                };
                putDevice(data);
            }.bind(this)

            this.getFirmwareInfoDisplay = function(type) {
                const mapping = {
                    'firmware_version': {
                        label: 'Firmware Version',
                        icon: 'fas fa-code-branch fa-2x',
                        color: 'primary',
                        titleSize: 'is-4'
                    },
                    'build_date': {
                        label: 'Build Date',
                        icon: 'fas fa-calendar fa-2x',
                        color: 'info',
                        titleSize: 'is-4'
                    },
                    'uptime': {
                        label: 'Uptime',
                        icon: 'fas fa-clock fa-2x',
                        color: 'warning',
                        titleSize: 'is-6'
                    },
                    'disk_usage': {
                        label: 'Storage',
                        icon: 'fas fa-hdd fa-2x',
                        color: 'link',
                        titleSize: 'is-6'
                    },
                    'memory_usage': {
                        label: 'Memory',
                        icon: 'fas fa-memory fa-2x',
                        color: 'danger',
                        titleSize: 'is-6'
                    },
                    'boot_time': {
                        label: 'Last Boot',
                        icon: 'fas fa-power-off fa-2x',
                        color: 'info',
                        titleSize: 'is-6'
                    }
                };
                return mapping[type] || {
                    label: type.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase()),
                    icon: 'fas fa-info fa-2x',
                    color: 'grey',
                    titleSize: 'is-6'
                };
            }.bind(this)

            this.firmwareUpdateClick = function(e) {

                self.parent.firmwareUpdateClick(e);
            }.bind(this)

            this.resetWifiClick = function(e) {
                if (!self.parent.selectedDevice) {
                    return;
                }

                self.parent.loadingResetWifi[self.parent.selectedDevice.device_id] = true;
                self.parent.update();

                var data = {
                    "device": self.parent.selectedDevice.device_id,
                    "method": "reset_wifi",
                    "activity_ref": "test",
                    "activity_step": 1,
                    "measureType": "immediate"
                };
                postDirectMethod(data, function(response) {

                    self.parent.loadingResetWifi[self.parent.selectedDevice.device_id] = false;

                    console.log("Reset WiFi response:", response);

                    if (response && response.data && Array.isArray(response.data)) {

                        self.parent.selectedDevice.resetWifiStatus = 'success';
                        self.parent.selectedDevice.resetWifiMessage = 'WiFi reset initiated successfully. The device should now be in AP mode.';

                        setTimeout(function() {
                            if (self.parent.selectedDevice) {
                                self.parent.selectedDevice.resetWifiStatus = null;
                                self.parent.selectedDevice.resetWifiMessage = null;
                                self.parent.update();
                            }
                        }, 10000);
                    } else {

                        self.parent.selectedDevice.resetWifiStatus = 'error';
                        self.parent.selectedDevice.resetWifiMessage = response?.message || "WiFi reset failed: Unknown error";

                        setTimeout(function() {
                            if (self.parent.selectedDevice) {
                                self.parent.selectedDevice.resetWifiStatus = null;
                                self.parent.selectedDevice.resetWifiMessage = null;
                                self.parent.update();
                            }
                        }, 15000);
                    }

                    self.parent.update();
                });
            }.bind(this)

            this.firmwareInfoClick = function(e) {
                if (!self.parent.selectedDevice) {
                    return;
                }

                var data = {
                    "device": self.parent.selectedDevice.device_id,
                    "method": "firmware_info",
                    "activity_ref": "test",
                    "activity_step": 1,
                    "measureType": "immediate"
                };

                self.firmwareInfo = null;
                self.firmwareLoading = true;
                self.update();

                postDirectMethod(data, function(response) {
                    console.log("Firmware info response:", response);

                    if (response && response.data && Array.isArray(response.data)) {
                        console.log("Response data:", response.data);
                        self.firmwareInfo = response.data;
                        self.firmwareLoading = false;

                        const versionInfo = response.data.find(item => item.type === 'firmware_version');
                        if (versionInfo) {
                            self.updateAvailable = isUpdateAvailable(versionInfo.value, self.LATEST_FIRMWARE_VERSION);
                            console.log(`Current: ${versionInfo.value}, Latest: ${self.LATEST_FIRMWARE_VERSION}, Update available: ${self.updateAvailable}`);
                        }
                    } else if (response && Array.isArray(response)) {

                        console.log("Response is array:", response);
                        self.firmwareInfo = response;
                        self.firmwareLoading = false;
                    } else {
                        console.log("Failed response:", response);
                        self.firmwareInfo = [{
                            type: "error",
                            value: "Failed to retrieve firmware information",
                            unit: "status"
                        }];
                        self.firmwareLoading = false;
                    }
                    self.update();
                });
            }.bind(this)

            this.cancelMonitor = function(monitor) {
                var data = {
                    "id": monitor.id,
                }
                deleteMonitor(data);
            }.bind(this)

            this.closeFirmwareNotification = function(e) {
                if (self.parent.selectedDevice) {
                    self.parent.selectedDevice.updateStatus = null;
                    self.parent.selectedDevice.updateMessage = null;
                    self.parent.update();
                }
            }.bind(this)

            this.closeWifiNotification = function(e) {
                if (self.parent.selectedDevice) {
                    self.parent.selectedDevice.resetWifiStatus = null;
                    self.parent.selectedDevice.resetWifiMessage = null;
                    self.parent.update();
                }
            }.bind(this)

            function getDeviceTelemetry(device) {
                self.telemetryLoading = true;
                self.update();
                libGetDeviceTelemetry(device).then(function(res) {
                    self.telemetryLoading = false;
                    self.update({
                        telemetry: res['data']['telemetry'],
                        telemetryError: undefined
                    });
                    events.emit('device_telemetry_loaded', res['data']['telemetry']);
                }).catch(function(error) {
                    console.error('GET Telemetry Error:' + error);
                    self.telemetryLoading = false;
                    self.update({
                        telemetry: [],
                        telemetryError: error
                    });
                });
            }

            function getDeviceMonitors(device) {
                self.monitorsLoading = true;
                self.update();
                libGetDeviceMonitors(device).then(function(res) {
                    self.monitorsLoading = false;
                    self.update({
                        monitors: res['data']['monitors'],
                        error: undefined
                    });
                }).catch(function(error) {
                    console.error('GET Monitors Error:' + error);
                    self.monitorsLoading = false;
                    self.update({
                        monitors: [],
                        error: error
                    });
                });
            }

            function putDevice(data) {
                self.savingEdits = true;
                self.renameError = undefined;
                self.update();
                libPutDevice(data).then(function(res) {
                    self.savingEdits = false;
                    self.isRenaming = false;
                    if (self.selectedDevice) {
                        self.selectedDevice.device_name = data.name;
                    }
                    self.update();
                    route('devices/' + res['data']['smartkits'][0]['id'], "Device Details");
                }).catch(function(error) {
                    console.error('PUT Device Error:' + error);
                    self.savingEdits = false;
                    self.renameError = 'Unable to save kit name. Please try again.';
                    self.update({
                        activities: [],
                        error: error
                    });
                });

            }

            function deleteMonitor(data) {
                self.monitorLoading = true;
                self.update();
                libDeleteMonitor(data).then(function(res) {
                    getDeviceMonitors(self.selectedDevice.device_id);
                }).catch(function(error) {
                    console.error('DELETE Monitor Error:' + error);
                    self.monitorLoading = false;
                    self.update({
                        monitors: [],
                        monitorError: error
                    });
                });
            }

            function postDirectMethod(data, callback) {

                libPostDirectMethod(data).then(function(res) {
                    if (callback) {
                        callback(res);
                    }
                }).catch(function(error) {
                    console.log(data['device'] + " :: " + error)
                    if (callback) {
                        callback({success: false, msg: error.message || 'Network error'});
                    }

                });
            }
});
